import { Field } from "@progress/kendo-react-form";
import TextEditor from "../../Common/TextEditor";
import { useReduxDispatch, useReduxSelector } from "../../../redux/hooks";
import { IMention } from "../../../types/User/IMention";
import {
  IMentionsHandleOnChange,
  IMentionsHandleOnClickForTextEditor,
  MentionsHandleOnChange,
  MentionsHandleOnClickForTextEditor,
} from "../../Common/Mentions/Handlers";
import { ShowMentions } from "../../Common/Mentions/utils";
import { SetTaggedUsers } from "../../../slices/TicketSlice";
import { SetHTML_Notes, SetTaggedDescription } from "../../../slices/ActionSlice";
import { IMentionsProps, Mentions } from "../../Common/Mentions/Mentions";
import { EditorChangeEvent } from "@progress/kendo-react-editor";
import { UserApi } from "../../../redux/api/UserApi";
import { useRef, useState } from "react";
import { TicketApi } from "../../../redux/api/TicketApi";
import { useParams } from "react-router-dom";

const ACTION_LOWERCASE = "action";
export const ActionNoteTextEditor = () => {
  const { ticketId } = useParams();
  const { data: ticket } = TicketApi.useGetTicketDetailsQuery({ ticketId: Number(ticketId) });
  const { data } = UserApi.useGetMentionConfigQuery();
  const [atActivated, setAtActivated] = useState(-1);
  const [mentionsText, setMentionsText] = useState("");
  const containerRef = useRef<HTMLDivElement | null>(null);

  const TaggedUsers = useReduxSelector(
    (state) => state.newTicket.TaggedUsers
  );
  const HTML_Notes = useReduxSelector(
    (state) => state.actionDetails.action.HTML_Notes
  );

  const dispatch = useReduxDispatch();
  const minChars = data ? data.Min_Chars - 1 : 0;

  function handleOnClick(person: IMention) {
    const required: IMentionsHandleOnClickForTextEditor = {
      dispatch: dispatch,
      SetDescription: SetHTML_Notes,
      SetTaggedDescription: SetTaggedDescription,
      SetTaggedUsers: SetTaggedUsers,
      TaggedUsers: TaggedUsers,
      setAtActivated: setAtActivated,
      atActivated: atActivated,
      setMentionsText: setMentionsText,
      mentionsText: mentionsText,
      HTML_Notes: HTML_Notes,
    };
    MentionsHandleOnClickForTextEditor(person, required);

  }

  function handleOnChange(e: EditorChangeEvent) {
    const eType = "EditorChangeEvent";
    const required: IMentionsHandleOnChange = {
      dispatch: dispatch,
      SetDescription: SetHTML_Notes,
      SetTaggedDescription: SetTaggedDescription,
      TaggedUsers: TaggedUsers,
      setAtActivated: setAtActivated,
      setMentionsText: setMentionsText,
      atActivated: atActivated,
      minChars: minChars.toString(),
    };
    MentionsHandleOnChange(e, eType, required);
    //dispatch(SetHTML_Notes(e.html));
  }

  const mentionsProps: IMentionsProps = {
    handleOnClick: handleOnClick,
    containerRef: containerRef,
    text: mentionsText,
    companyId: ticket?.Company_Id
  };


  return (
    <div ref={containerRef} className="inline-block w-full pt-2 align-top">
      <Field
        id={ACTION_LOWERCASE}
        name={ACTION_LOWERCASE}
        component={TextEditor}
        onChange={handleOnChange}
        HTML={HTML_Notes || ""}
        autoFocus={false}
      />
      {ShowMentions(mentionsText, minChars) && (
        <Mentions props={mentionsProps} />
      )}
    </div>
  );
};
